import React, { useMemo } from 'react';
import { useStore } from '@roc/client-portal-shared/hooks';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import { isLocalHost } from '@roc/feature-utils';

interface RedirectUrlProps {
  type: 'inspection' | 'loan' | 'draw';
  id: string;
}

export default function useRedirectUrl({ type, id }: RedirectUrlProps) {
  const { globalStore } = useStore();
  const { loanRoutesConfig } = useLoanRoutes();

  const url = useMemo(() => {
    let parentHostName = 'http://localhost:3000';

    if (!isLocalHost()) {
      try {
        parentHostName = window.parent.location.origin + '/nportal';
      } catch (e) {
        console.error('Cannot access parent window origin:', e);
      }
    }

    switch (type) {
      case 'inspection':
        return `${parentHostName}/#/inspections/${id}/report`;
      case 'loan':
        return globalStore.isInternalPortal
          ? `${parentHostName}/#/loan_information/${id}`
          : loanRoutesConfig.loans(id).children.dashboard.url;
      case 'draw':
        return globalStore.isInternalPortal
          ? `${parentHostName}/#/loan_information/${id}/draws`
          : loanRoutesConfig.loans(id).children.draws.url;
      default:
        return '';
    }
  }, [globalStore, loanRoutesConfig, type, id]);

  return url;
}
